import React from 'react';
import { match } from 'react-router-dom';
import { RedirectUrlMissingQueryParam } from '@qover/molecules';

type RedirectionProps = {
  match: match;
};

export const QuoteRedirection: React.FC<RedirectionProps> = props => (
  <RedirectUrlMissingQueryParam to={`${props.match.path}/quote`} param="id">
    {props.children}
  </RedirectUrlMissingQueryParam>
);
